import React, { useState } from 'react';

const DocumentUpload = ({
    formData,
    handleInputChange,
    handleFileUpload,
    handleRemoveFile
}) => {
    const [previewFile, setPreviewFile] = useState(null);
    const [fileErrors, setFileErrors] = useState({});

    return (
        <div className="form-section mb-2">
            <h3 className="section-heading">Documents Attached</h3>
            <div className="row">
                <div className="col-12">
                    <div className="form-group">
                        <div className="documents-list">
                            <div className="row">
                                {[
                                    { key: 'pan', label: '1. PAN' },
                                    { key: 'aadhaar', label: '2. ADHAAR' },
                                    { key: 'bankDetails', label: '3. BANK DETAILS' },
                                    { key: 'passportCopy', label: '4. PASSPORT COPY' },
                                    { key: 'drivingLicense', label: '5. DRIVING LICENSE' },
                                    { key: 'coiMoaAoa', label: '6. COI/MOA/AOA/EFD' },
                                    { key: 'boardResolution', label: '7. BOARD/FIRM/LLP RESOLUTION' }
                                ].map((doc, index, array) => (
                                    <div className={`col-12 col-md-6 ${index === array.length - 1 ? '' : 'col-lg-3'} mb-4`} key={doc.key}>
                                        <div className="document-item-wrapper h-100 p-2">
                                            <div className="checkbox-item mb-2 d-flex align-items-center">
                                                <input
                                                    type="checkbox"
                                                    id={`doc_${doc.key}`}
                                                    name={`documentsAttached.${doc.key}`}
                                                    checked={formData.documentsAttached[doc.key]}
                                                    onChange={handleInputChange}
                                                    className="form-checkbox"
                                                    style={{ width: '20px', height: '20px', marginRight: '10px' }}
                                                />
                                                <label htmlFor={`doc_${doc.key}`} style={{ fontSize: '1rem', fontWeight: '500' }}>{doc.label}</label>
                                            </div>

                                            {formData.documentsAttached[doc.key] && (
                                                <div
                                                    className="upload-area mt-2 position-relative d-flex flex-column justify-content-center align-items-center"
                                                    style={{
                                                        width: '135px',
                                                        aspectRatio: '1 / 1',
                                                        border: fileErrors[doc.key] ? '2px dashed #dc3545' : '2px dashed #6c757d',
                                                        borderRadius: '10px',
                                                        backgroundColor: fileErrors[doc.key] ? '#f8d7da' : '#f8f9fa',
                                                        overflow: 'hidden',
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                >
                                                    <input
                                                        type="file"
                                                        id={`file_${doc.key}`}
                                                        accept="image/png, image/jpeg, image/jpg, image/webp, application/pdf"
                                                        style={{ display: 'none' }}
                                                        onChange={(e) => {
                                                            const file = e.target.files[0];
                                                            if (file) {
                                                                if (file.size > 2 * 1024 * 1024) { // 2MB limit
                                                                    setFileErrors(prev => ({ ...prev, [doc.key]: "Allowed file max 2mb" }));
                                                                    e.target.value = "";
                                                                    return;
                                                                }
                                                                // Clear error if valid file
                                                                setFileErrors(prev => {
                                                                    const newErrors = { ...prev };
                                                                    delete newErrors[doc.key];
                                                                    return newErrors;
                                                                });
                                                                handleFileUpload(doc.key, file);
                                                            }
                                                        }}
                                                    />

                                                    {formData.uploadedFiles && formData.uploadedFiles[doc.key] ? (
                                                        <div className="uploaded-file-preview w-100 h-100 position-relative d-flex justify-content-center align-items-center"
                                                            style={{ backgroundColor: '#fff' }}
                                                            onMouseEnter={(e) => {
                                                                const overlay = e.currentTarget.querySelector('.hover-overlay');
                                                                if (overlay) overlay.style.opacity = '1';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                const overlay = e.currentTarget.querySelector('.hover-overlay');
                                                                if (overlay) overlay.style.opacity = '0';
                                                            }}
                                                        >
                                                            {formData.uploadedFiles[doc.key].type.startsWith('image/') ? (
                                                                <img
                                                                    src={URL.createObjectURL(formData.uploadedFiles[doc.key])}
                                                                    alt="Preview"
                                                                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                                                />
                                                            ) : (
                                                                <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center p-2">
                                                                    <span style={{ fontSize: '2rem' }}>📄</span>
                                                                    <span className="small text-break">{formData.uploadedFiles[doc.key].name}</span>
                                                                </div>
                                                            )}

                                                            {/* Remove Button - Always visible */}
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-sm position-absolute d-flex justify-content-center align-items-center"
                                                                onClick={() => handleRemoveFile(doc.key)}
                                                                title="Remove"
                                                                style={{
                                                                    top: '5px',
                                                                    right: '5px',
                                                                    zIndex: 20,
                                                                    width: '28px',
                                                                    height: '28px',
                                                                    padding: 0,
                                                                    borderRadius: '50%'
                                                                }}
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="20"
                                                                    height="20"
                                                                    viewBox="0 0 24 24"
                                                                    fill="none"
                                                                    stroke="white"
                                                                    strokeWidth="2"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                >
                                                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                                                </svg>

                                                            </button>

                                                            <div
                                                                className="hover-overlay position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center gap-2"
                                                                style={{
                                                                    backgroundColor: 'rgba(0,0,0,0.5)',
                                                                    opacity: '0',
                                                                    transition: 'opacity 0.2s',
                                                                    zIndex: 10
                                                                }}
                                                            >
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-primary"
                                                                    onClick={() => document.getElementById(`file_${doc.key}`).click()}
                                                                    title="Change Image"
                                                                >
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="20"
                                                                        height="20"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        stroke="white"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    >
                                                                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>

                                                                        <path d="M8 16l2.5-.5L17 9l-2.5-2.5L8 13.5 7.5 16z"></path>
                                                                        <line x1="13.5" y1="6.5" x2="17" y2="10"></line>
                                                                    </svg>

                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-primary"
                                                                    onClick={() => setPreviewFile(formData.uploadedFiles[doc.key])}
                                                                    title="Show Preview"
                                                                >
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        width="20"
                                                                        height="20"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        stroke="white"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    >
                                                                        <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"></path>
                                                                        <circle cx="12" cy="12" r="3"></circle>
                                                                    </svg>

                                                                </button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className="upload-placeholder d-flex flex-column align-items-center text-muted cursor-pointer"
                                                            onClick={() => document.getElementById(`file_${doc.key}`).click()}
                                                            style={{ cursor: 'pointer', width: '100%', height: '100%', justifyContent: 'center' }}
                                                        >
                                                            {fileErrors[doc.key] ? (
                                                                <>
                                                                    <span className="text-danger text-center mb-2" style={{ fontSize: '0.85rem', lineHeight: '1.2' }}>
                                                                        {fileErrors[doc.key]}
                                                                    </span>
                                                                    <span className="btn btn-sm btn-outline-danger" style={{ fontSize: '0.75rem', padding: '2px 8px', borderRadius: '4px' }}>
                                                                        Upload Again
                                                                    </span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <span style={{ fontSize: '2rem' }}>+</span>
                                                                    <span>Upload</span>
                                                                    <span className="small text-muted" style={{ fontSize: '0.75rem' }}>(Max 2MB)</span>
                                                                </>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* File Preview Modal */}
            {previewFile && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0,0,0,0.8)',
                    zIndex: 99999999999,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '20px'
                }} onClick={() => setPreviewFile(null)}>
                    <div style={{
                        backgroundColor: '#fff',
                        padding: '10px',
                        borderRadius: '8px',
                        maxWidth: '90%',
                        maxHeight: '90%',
                        position: 'relative',
                        overflow: 'auto',
                        display: 'flex',
                        flexDirection: 'column'
                    }} onClick={e => e.stopPropagation()}>

                        <button
                            onClick={() => setPreviewFile(null)}
                            style={{
                                position: 'absolute',
                                top: '5px',
                                right: '5px',
                                background: 'none',
                                border: 'none',
                                fontSize: '1.5rem',
                                cursor: 'pointer',
                                zIndex: 10
                            }}
                        >
                            &times;
                        </button>

                        {previewFile.type.startsWith('image/') ? (
                            <img
                                src={URL.createObjectURL(previewFile)}
                                alt="Full View"
                                style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
                            />
                        ) : (
                            <iframe
                                src={URL.createObjectURL(previewFile)}
                                title="PDF View"
                                style={{ width: '74vw', height: '80vh', border: 'none' }}
                            />
                        )}
                        <div className="text-center mt-2">
                            <span className="text-secondary">{previewFile.name}</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DocumentUpload;
